import { responseUI } from "@base/themes/response";
import { Button, ButtonProps } from "antd";
import React from "react";

interface IProps extends ButtonProps {
  children?: string | React.ReactNode;
}

// Forwards its ref so a Tooltip, Dropdown or Popconfirm around it need not fall back to findDOMNode.
const ButtonUI = React.forwardRef<HTMLButtonElement | HTMLAnchorElement, IProps>(function ButtonUI(props, ref) {
  //! state
  const { children, ...res } = props;
  //! function
  //! render
  return (
    <Button ref={ref} className={`rounded-lg text-base ${res.className} ${responseUI.text.default}`} type={res.type ?? "primary"} {...res}>
      {children}
    </Button>
  );
});

export default ButtonUI;
